<template>
  <div class="shipments">
    <PageMenu :linksList="linksComputedList" />
    <router-view />
  </div>
</template>

<script>
/* eslint-disable */
import {mapGetters} from 'vuex';
import PageMenu from '@/components/global/pageMenu';

export default {
  name: 'ShipmentsIndex',
  components: { PageMenu },
  computed: {
    ...mapGetters([
      'get_user_permission',
      'get_active_subaccount'
    ]),
    linksComputedList() {
      return [
        {
          name: 'Book shipment',
          link: '/shipments/book-shipment',
          visible: this.get_user_permission('shipment/book-shipment').view,
        },
        {
          name: 'Waiting for approval',
          link: '/shipments/unapproved-shipments',
          visible: this.get_user_permission('shipment/unapproved-shipments').view,
        },
        {
          name: 'drafts',
          link: '/shipments/drafts',
          visible: this.get_user_permission('shipment/draft').view,
        },
        {
          name: 'all_shipments',
          link: '/shipments/all-shipments',
          visible: this.get_user_permission('shipment/history').view,
        },
        {
          name: 'End of Day',
          link: '/shipments/end-of-day',
          visible: this.get_user_permission('shipment/end-of-day').view,
        },
        {
          name: 'Consolidations',
          link: '/shipments/consolidations',
          visible: this.get_user_permission('shipment/consolidations').view && parseInt(this.get_active_subaccount.backoffice_id) === 1,
        },
      ]
    },
  },
};
</script>
